import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @author PKr
 * @author Tomas Leity
 */


import { jsonConversions, WindowItemConverter, WindowItemUpdateDTOConverter, CodebookItemConverter, WindowItemPromoPriceDTOConverter, WindowItemProductSuppliersConverter, WindowItemHistoryTableConverter } from '@logio/common-be-fe';
import { List } from 'immutable';
import { Inject } from '@logio/typescript-ioc';
import { CRUTransportLayer } from '../CRUTransportLayer';
import { CONSTANTS } from '../../../constants';
import logger from '../../logger';
import api from '../../api';
export var WindowItemLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(WindowItemLayer, _CRUTransportLayer);

  function WindowItemLayer() {
    var _this;

    _classCallCheck(this, WindowItemLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemLayer).call(this, CONSTANTS.API.ENDPOINTS.WINDOW_ITEM));
    /**
     * Window item partial entity update
     * @param partialWindowItems array of changes
     * @param sessionId
     */

    _this.partialUpdate = function (partialWindowItems, sessionId) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_UPDATE(sessionId)).post({
        windowItems: partialWindowItems.map(function (item) {
          return _this.windowItemUpdateDTOConverter.toDocument(item, jsonConversions);
        })
      }, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this.getConverter().toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };

    return _this;
  }

  _createClass(WindowItemLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.windowItemConverter;
    }
    /**
     * Gets all entities from the repository. Use with caution in cases where there are too many entities in repository!
     * @param windowId
     * @param sessionId
     * @returns all entities from the repository.
     */

  }, {
    key: "getItemsByWindowId",
    value: function getItemsByWindowId(windowId, sessionId) {
      var _this2 = this;

      return api(CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_BY_WINDOW_ID(windowId, sessionId)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).forEach(function (item) {
          arr.push(_this2.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Create window items based on productsIds
     * @param windowId
     * @param productIds
     * @param sessionId
     */

  }, {
    key: "createWindowItems",
    value: function createWindowItems(windowId, productIds, sessionId) {
      var _this3 = this;

      return api(CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_CREATE(sessionId)).post({
        windowId: windowId,
        productIds: productIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this3.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Delete window items from window
     * @param windowItemIds
     * @param sessionId
     */

  }, {
    key: "delete",
    value: function _delete(windowItemIds, sessionId) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_DELETE(sessionId)).delete({
        data: {
          windowItemIds: windowItemIds
        }
      }).then(function (response) {
        return response.data.result;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Set system volume for window items
     * @param windowItemIds
     * @param windowId
     * @param sessionId
     * @param log
     */

  }, {
    key: "setSystemVolume",
    value: function setSystemVolume(windowItemIds, windowId, sessionId) {
      var log = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_SET_SYS_VOL(log, sessionId)).post({
        windowItemIds: windowItemIds,
        windowId: windowId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return response.data.progress;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Get simulated items based on simulation report
     * @param windowId
     */

  }, {
    key: "getSimulatedItems",
    value: function getSimulatedItems(windowId) {
      var _this4 = this;

      return api(CONSTANTS.API.ENDPOINTS.SIMULATED_WINDOW_ITEM_BY_WINDOW_ID(windowId)).get({
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this4.getConverter().toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Get promo price unit for recalculation
     */

  }, {
    key: "getPromoPriceUnitsCodebook",
    value: function getPromoPriceUnitsCodebook() {
      var _this5 = this;

      return api(CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_PROMO_PRICE_UNITS).get({
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this5.codebookItemConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Get recalculated values for promo price
     * @param windowItemIds
     * @param sessionId
     */

  }, {
    key: "recalculatePromoPricesUnit",
    value: function recalculatePromoPricesUnit(windowItemIds, sessionId) {
      var _this6 = this;

      return api(sessionId ? "".concat(CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_PROMO_PRICE, "?sessionId=").concat(sessionId) : CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_PROMO_PRICE).post({
        windowItemIds: windowItemIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this6.windowItemPromoPriceDTOConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Get historic {@link WindowItem} table data based on promotion and product parameters
     * @param promotionId
     * @param gosToProductMapping
     */

  }, {
    key: "getHistoricTable",
    value: function getHistoricTable(promotionId, gosToProductMapping) {
      var _this7 = this;

      var apiConfig = {
        responseType: 'json'
      };
      var apiData = {
        promotionId: promotionId,
        gosToProductMapping: gosToProductMapping ? gosToProductMapping.toArray() : undefined
      };
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_HISTORY_TABLE).post(apiData, apiConfig).then(function (response) {
        return List((response.data.result || []).map(function (item) {
          return _this7.windowItemHistoryTableConverter.toObject(item, jsonConversions);
        }));
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Get historic {@link WindowItem} table data based on {@link WindowItem} id
     * @param windowItemId
     * @param sessionId
     */

  }, {
    key: "getHistoricTableByItem",
    value: function getHistoricTableByItem(windowItemId, sessionId) {
      var _this8 = this;

      var apiConfig = {
        responseType: 'json'
      };
      var apiData = {
        windowItemId: windowItemId
      };
      return api("".concat(CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_HISTORY_TABLE_BY_ITEM).concat(sessionId ? "?sessionId=".concat(sessionId) : '')).post(apiData, apiConfig).then(function (response) {
        return List((response.data.result || []).map(function (item) {
          return _this8.windowItemHistoryTableConverter.toObject(item, jsonConversions);
        }));
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Find suppliers for specified windowItemIds. Includes preferred and other suppliers.
     * @param windowItemIds
     * @param sessionId
     * @returns {List<WindowItemProductSuppliers>}
     */

  }, {
    key: "findSuppliers",
    value: function findSuppliers(windowItemIds, sessionId) {
      var _this9 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api("".concat(CONSTANTS.API.ENDPOINTS.WINDOW_ITEM_FIND_SUPPLIERS).concat(sessionId ? "?sessionId=".concat(sessionId) : '')).post({
        windowItemIds: windowItemIds.toArray()
      }, apiConfig).then(function (response) {
        return List((response.data.result || []).map(function (productSupplier) {
          return _this9.windowItemProductSuppliersConverter.toObject(productSupplier, jsonConversions);
        }));
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return WindowItemLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", WindowItemConverter)], WindowItemLayer.prototype, "windowItemConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowItemUpdateDTOConverter)], WindowItemLayer.prototype, "windowItemUpdateDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowItemPromoPriceDTOConverter)], WindowItemLayer.prototype, "windowItemPromoPriceDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowItemProductSuppliersConverter)], WindowItemLayer.prototype, "windowItemProductSuppliersConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowItemHistoryTableConverter)], WindowItemLayer.prototype, "windowItemHistoryTableConverter", void 0);

__decorate([Inject, __metadata("design:type", CodebookItemConverter)], WindowItemLayer.prototype, "codebookItemConverter", void 0);